import { MEDIA_TYPES } from "@pathwright/ui/src/components/filestack/constants"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Text from "@pathwright/ui/src/components/ui/Text"
import Select from "react-select"
import { ChooseFileTypeWrapper, SelectWrapper } from "../ui"
import { getAllowedFileOptions } from "../utils"

export const ChooseFileType = ({ currentFileType, onChangeFileType }) => {
  const { tc, t } = useTranslate()
  const allowedFileOptions = [
    ...getAllowedFileOptions(t),
    {
      value: MEDIA_TYPES.LINK,
      label: t("link")
    }
  ]

  return (
    <ChooseFileTypeWrapper>
      <Text.Body style={{ marginRight: "0.5rem", textAlign: "center" }}>
        {tc("Upload")}{" "}
      </Text.Body>
      <SelectWrapper>
        <Select
          onChange={onChangeFileType}
          alignCenter={true}
          value={allowedFileOptions.find((option) => option.value === currentFileType) || allowedFileOptions[0]}
          options={allowedFileOptions}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              minWidth: "150px",
              width: "100%",
              maxWidth: "250px"
            })
          }}
          menuContainerStyle={{ zIndex: "100000000" }}
          menuStyle={{
            zIndex: "100000000",
            position: "relative",
            border: "0"
          }}
          wrapperStyle={{ minWidth: "150px", width: "50%", maxWidth: "250px" }}
          multi={false}
          styleType="blank"
        />
      </SelectWrapper>
    </ChooseFileTypeWrapper>
  )
}

export default ChooseFileType
